export default __webpack_public_path__ + "static/media/wallet-connect.706610b8.svg";